<template lang="pug">
  .gw-headline__item.gw-headline__dropdown.ph-headline__dropdown_right(
    :class="getDropdownLinkClass",
    v-click-outside="closeDropdown",
    v-if="isUserProcessed"
  )

    a.gw-headline__signup(
      @click="clickLogin()",
      :class="dropDownClass"
    )
      img.gw-headline__avatar(:src="getAvatarPath")
      .gw-headline__login {{ getButtonLabel }}


    .gw-headline__dropdown-list.gw-user-dropdown(v-if="is_dropdown_show")
      NavItem(
        v-for="(link, index) in userLinks",
        :key="index",
        :link="link"
      )
</template>

<script>
import NavItem from "./MyGamesHeadlineUserNavItem";
import DropdownMixin from "./DropdownMixin";
import { createNamespacedHelpers } from "vuex";
import AuthService from "../../../libs/auth/AuthService";
const { mapState, mapGetters } = createNamespacedHelpers("global");

export default {
  name: "MyGamesHeadlineUser",

  components: {
    NavItem,
  },
  mixins: [DropdownMixin],
  props: {
    userLinks: Array,
  },

  computed: {
    ...mapGetters([
      "isUserNotAuthed",
      "isUserInProject",
      "isUserAuthedNotRegistered",
      "isUserProcessed",
    ]),
    ...mapState(["user"]),
    getButtonLabel() {
      return !this.isUserInProject ? this.$t("mygames.login") : this.user.login;
    },
    dropDownClass() {
      return { "gw-headline__dropdown-default": this.isUserInProject };
    },
    getAvatarPath() {
      if (this.user) {
        return `https://avatar.my.games/avatar/${this.user.id}.90.jpeg`;
      } else {
        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAACMpJREFUaAXdWltsVEUYnjl763Z36f2KpRSpEYpFLChvgsQEEiM+YEJijD6QeCH61BejJE2M8QWiSIg+mBhiNCbyUBITjEbAoAahpQoUCS2XttBub3TbbtvdPXvO+P27Pe1ezu45Z3dpjJNs9szM///zf3P5559/hrPCJD4+Pu71+Xw1siw/KUn2x1SVrZEkXiuEWMW5KKZmhODznPMZVRV+SWKDqhq96XA4/pqdnR2tqqoKEkm+6vB8BAwPDxdXVFSskWVlC+Rs41x6lDG1mjHJYU6uKoN2TAj1FugvORy2nsnJycH6+vp5c/zpVDkB6uvrc1VW1j0OBfagx7cBRCMUS5duqUQFtTSAEb2EDjo9MTFyo7m5OWxJBIitAuJTU8FWp9P2MhrejhEptdqgGXqMWAAddSESUb4vK/NeAY/pqWgaEAB45+dD+yF7L3qyzoxi+dOoI+jzU8XFRd8BIK0xw2QK0MLCQhMW+WuQtgcN2AylFpRAKBB3GkbkhNvtvmMk2hDQ5ORsS1GR/V0AaTMSplePkZ2BlZujOlg5D3p6lR6dcZnoDoWin1VU+Hqz0WYFNDU1u8PpdLwDAVj0VpIK5cVVQPhFltk1xuRAnNtR6nCwTeicXQD2RA6G5K6qysewPfyaSZuMgB48mN3kcjk6wLg2E7NeOYAEJUl0YpqehEm/D5rUBc1hmldj+uxTVf4SgHn15GQpuxsOyx3l5T50VHrStbVQZq3LZaeRWZvOkq1ERBhTvhwdHf0CYO6BMhUMMQuqIxqiRRY8llJMN9JRjysNEFkzGIDXra8ZQRvJT/AYTjY1NYX0GkssIxqiJR6AIl4LibeRjqRrKlMSoI6ODilumtnuVEIT+euRSOgrM2A0WURLPMhf18os/O8mXUnnRJ6kNYRNc7PDwT/i3FabSGT8LaJCsONer/trY9p0imBw4VXO2UHGuD29NnOJEIpflsX72Hz/1qiW0PX29jrJA7AOhkSJsWg0/Lsm1Op/nFeMWeUjXUln0l3jXQJUX9+4Ab28Xauw8g++W1gPZNFySsRLMnJhJp1Jd403BmhoaMi96Gjm5Jthcfbn4khqShAvydDyVv5h9rG32fYQBuKLASopKWnEbv60FUGJtOCdTszn8p2PDNKdMFC7BIjjQEbnmTVUYD2RVyBZdvNT24nLsGi9l4XgMBnDwCUMtQeO39Yc3JBFcRLjXPUsy87tKy5jaUlbFCIxwhDDEg6HcUyW1luUkEQuSbFzUdIWkERgnMEsye9sRRgIi0QxAJjdKuM2M1PAi94wNjaW8ygRL8nI3IKZGlEVi2dwbm/GMlqy42ZYU2lgOhuLi4vXpZabzRMvyTBLr0/HnYRFgtnLUxC6g4sKrMFdqW6IfsPJpXEeCccJkpFfIix8bi50CmJW5ycKYRJVvaco4sPSUk+3FVmBwFybzcYPYQ09YoUvA+19snK+DJWWikkhHN7e8Ptnq80yEi3xFAgMHSp9mHLxIKBZJbLT8S0ej/2t0dFgTXY6xoiGaDFhaQ8sSCIsmHLzFzD/LXm52VtXBeovwnv+BqfSK5jXSdEa9KIXh7NWGIFXQAfvRMrH3KeookY5XPczaDTHwEWKvIQsXPspZC8hxnaZMftEvCpaiVjeU/hGlNVWlkBekE901gwZhU5IK8SCzKKUiMYrrZ13sgjMVHVPosB5ptrClROQhw4Gllb47ZjrA1AcvlwhUyxGgFERKjwAeJxazICTEcKaiQUrCWSuzpuusoTFLkS0DzssIi/5eAux6OYkWhnHfjQEWaP0DXM8w1gUZx0bbhlQyhUH1pMTNCU2G6tUFLUGNA2oItcLG2s+oygihMVO9zOKwsYhMIfNVR1GbK1LktRuRVH6oOh4aWkpBRXJ0plKWMilcCoro1G2Ht+YKWJrbvsSHycsdpfL5YcZ7Ye3ahoQLFcQU+lsNKp2yvL8rerq6iTTbArJIhEsLHUA/fr9fv95r7dsHTpmL6bPc1asL44f/S6Xm9YQnwsG57tQ8KyZMxHA3ADdiUBg/LeGhoYFK8ob0dbW1lIM/CpGqi8YDP2BkUfsjW001kuFQWDAwOdoQxW4Guyx2eyD+M56agWY84oiH8dxt99IuXzqoRgFKs8EAoEBhKLeBih0dtZE15s9oBAxKxMMBgcxhS5mY8FGeQ1BwU8eNphEHbAeKRL0KdpG4D9zIt2np6fJWseDJHSnSdeAGGqayzpJvQ3rdKS8vJxGcUUTzkpDQtiPwJ+HDumJdCbdtem/tA8MDw/8g4UIvy49YcgHR0YGb6bXrEyJ3z+IrUXS7UzSmXTXNFkC1NLSEqE7TQqvapXL/7y1rq7BaB4vkxf4q66ubge8gNZUsaQr6Uy6a3VLgKjg6NHDV9ETnVhbi75XnAyLtBxW8ADd5mmMK/VPbUKnA6RDcpsiSrqSzonlaa475iRdDrdj134hkTD+rd7GRvq5z+c+h7zpzTNdjnEJHc3b29t3Quk3sdSb0jnED7hMPgygSXtgGiBipMsk2PX3AKpNRxAeSijfguYUXn/MptfnX4IbvlUuV/GLmBU4M9l0IlKiG3G4j3HeupvaWtKU0yqJMByOHkM+jQEgq9FrBz0ezwd40rKxq6sL/llhEsmKX4W6D8GJPagPhsV00wNDWuiOkKae8aWxOoTF+rPTaT+LDfAOhp82RMsJ07wIe+E6TK2dUOn5LL7cQCQiHysr853L1EhWQMRk5lofCk3gorgX6+syPN6eUCg0ZPAYKfbYSZKK1uAuFzEFgVMs34gOqcykKGjyv9bXhGO9mHx4ISIYMVxc8RG7nQ3Aix/FNfyUzeaMmVVFiTglyVGGo0MNvOtGKFmHF1uIEmU7uhT44YUGatH67YcSFp7G0MEudrjTLCJmBB3qzB7sHtLTGA0U/unx0mZcA+4DwJV4vHRy8f5U65AEVfQ/DdeQHtvy8zJpN1yPZ0ADL13XYOqxZyjDYDIGJ5n9Kcvqjyv1vCxJmf/NA8AkVPHMf+aJ5r/zDQcytogtQAAAAABJRU5ErkJggg==";
      }
    },
  },

  methods: {
    clickLogin() {
      if (this.isUserNotAuthed) {
        AuthService.showSignin();
      } else if (this.isUserAuthedNotRegistered) {
        AuthService.showProjectReg();
      } else {
        this.toggleDropdown();
      }
    },
  },
};
</script>

<style lang="stylus">
.gw-headline__signup
  display flex
  align-items center
  height 100%

.gw-headline__avatar
  background-position center center
  background-repeat no-repeat
  background-size 24px 24px
  border-radius 50%
  margin-right 8px
  width 24px
  height 24px
  overflow hidden

.gw-headline__dropdown-list.gw-user-dropdown
  right 0
  left auto

.gw-headline__login
  @media (max-width: 860px)
    display none
</style>
